import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { NewsletterBanner as NewsletterBanner$1 } from '@grandvisionhq/content';
import { compose } from '@grandvisionhq/utils';
import { useSubscribeNewsletter } from '../../hooks/use-subscribe-newsletter.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';

const CmsNewsletterBanner = ({ content  })=>{
    const subscribeNewsletterData = useSubscribeNewsletter();
    return /*#__PURE__*/ React.createElement(NewsletterBanner$1, swcHelpers.extends({}, subscribeNewsletterData, content, {
        consent: content.consent.value
    }));
};
var NewsletterBanner = compose(withHidableContent, withBloomreachData, withEditableContent)(CmsNewsletterBanner);

export { CmsNewsletterBanner, NewsletterBanner as default };
//# sourceMappingURL=NewsletterBanner.js.map
